import React, { Component } from 'react';
import { graphql } from '@apollo/client/react/hoc';
import {gql} from '@apollo/client';

export default function newsWithData(WrappedComponent, options = {}) {
	const HOC = class extends Component {
		constructor(props) {
			super(props);
			this.wrapped = graphql(gql `query galleryPageQuery {
					galleryPages(q:"fields.route=${props.match.path.replace('/', '')}") {
					  backgroundHeader
					  backgroundDescription
					  route
					  pageDescription
					  galleryGroups{
					  	name
					  	description
					  	galleryItems{
							visibilityValue
					  		name
					  		description
					  		releaseDate
					  		featuredVideo
					  		snapshotTime
					  		showDetails
					  		openableFileLink
					  		file{
			                  title
			                  description
			                  url
			                  __typename
			                }
			                fileThumbnailOverride{
			                	title
								description
								url
								__typename
			                }
			            }
					  }
					hideFilters
					additionalInformation
				    backgroundImage {
				      title
				      description
				      url
				    }
					}
				  feedbackComponents {
				    feedbackHeader
				    feedbackDescription
				    feedbackCtAtext
				    feedbackImage {
				      title
				      description
				      url
				    }
				  }
				  headerFooterComponents {
				    footerHeader
				    footerBody
				    copyrightHolder
				    primaryNavigationLinks{
				      route
				      text
				    }
					seasonalPrimaryNavigationLinks{
					  route
					  text
					}
				    footerLinks{
				      route
				      text
				    }
				    seasonalFooterLinks{
				      route
				      text
				    }
				    secondaryFooterLinks {
				      route
				      text
				    }
				    footerLogo {
				      title
				      description
				      url
				    }
				  }
				  exploreComponents {
					    isNotDisplayed
					    exploreTitle
					    exploreTile {
					    backgroundImage {
						        title
						        description
						        url
						      }
					      route
					      title
					      ctaText
					  }
				  }
				  globalSites{feedback {
						 feedbackHeader
						 feedbackDescription
						 feedbackCtAtext
					   feedbackImage {
						 title
						 description
						 url
						}
					}
				  mainNavigation {
						 footerHeader
						 footerBody
						 copyrightHolder
						 primaryNavigationLinks{
							 route
							 text
						 }
						 seasonalPrimaryNavigationLinks{
						  route
						  text
						 }
						 footerLinks{
						   route
						   text
						 }
					     seasonalFooterLinks{
					      route
					      text
					     }
						 secondaryFooterLinks {
						   route
						   text
						 }
						 footerLogo {
						   title
						   description
						   url
						 }
				   }
				   cubsLogo{
		              title
		              url
		            }
			  }
}
	  `, { name: 'galleryPageQuery' })(WrappedComponent);
		}

		render() {
			const Wrapped = this.wrapped;
			return <Wrapped {...this.props}/>;

		}
	};

	return HOC;
}